import ws from "../ws";
import getToken from "../getToken";
import moment from "moment";
import "moment/locale/ru";

const WAY_FOR_PAY_MERCHANTS_GET_LIST_PROGRESS = 'WAY_FOR_PAY_MERCHANTS_GET_LIST_PROGRESS';
const WAY_FOR_PAY_MERCHANTS_GET_LIST_SUCCESS = 'WAY_FOR_PAY_MERCHANTS_GET_LIST_SUCCESS';
const WAY_FOR_PAY_MERCHANTS_GET_LIST_FAILED = 'WAY_FOR_PAY_MERCHANTS_GET_LIST_FAILED';
const WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_PROGRESS = 'WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_PROGRESS';
const WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_SUCCESS = 'WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_SUCCESS';
const WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_FAILED = 'WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_FAILED';
const WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_PROGRESS = 'WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_PROGRESS';
const WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_SUCCESS = 'WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_SUCCESS';
const WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_FAILED = 'WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_FAILED';
const WAY_FOR_PAY_MERCHANTS_CLEAR_STATE = 'WAY_FOR_PAY_MERCHANTS_CLEAR_STATE';

const merchantGetListProgress = () => ({
  type: WAY_FOR_PAY_MERCHANTS_GET_LIST_PROGRESS,
});

const merchantGetListSuccess = payload => ({
  type: WAY_FOR_PAY_MERCHANTS_GET_LIST_SUCCESS,
  payload,
});

const merchantGetListFailed = () => ({
  type: WAY_FOR_PAY_MERCHANTS_GET_LIST_FAILED,
});

const merchantStartFormSubmit = () => ({
  type: WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_PROGRESS,
});

const merchantFormSubmitSuccess = () => ({
  type: WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_SUCCESS,
});

const merchantFormSubmitFailed = () => ({
  type: WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_FAILED,
});

const merchantGetFormProgress = () => ({
  type: WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_PROGRESS,
});

const merchantGetFormSuccess = payload => ({
  type: WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_SUCCESS,
  payload,
});

const merchantGetFormFailed = () => ({
  type: WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_FAILED,
});

const merchantClearState = () => ({
  type: WAY_FOR_PAY_MERCHANTS_CLEAR_STATE,
});

const convertListToTable = payload => {
  const { data } = payload;
  const {
    docs, hasNextPage, hasPrevPage, limit, nextPage, page, pagingCounter, prevPage, totalDocs, totalPages,
  } = data;

  const pagination = {
    docsNumber: docs.length,
    hasNextPage,
    hasPrevPage,
    limit,
    nextPage,
    page,
    pagingCounter,
    prevPage,
    totalDocs,
    totalPages,
  };

  let number = page * limit - limit;

  const list = docs.map(doc => ({
    number: ++number,
    id: doc.id,
    name: doc.name,
    merchantId: doc.merchantId,
    isArchive: doc.isArchive,
    updatedAt: moment(doc.updatedAt).format("LLL"),
  }));

  return { list, pagination };
};

const getMerchantsList = params => dispatch => {
  const token = getToken();
  dispatch(merchantGetListProgress());

  ws.emit('api/app/wayForPayMerchants/list', { token, payload: params }, (data) => {
    const { status, payload } = data;

    if (status === 'ok') {
      dispatch(merchantGetListSuccess(convertListToTable(payload)));
    } else {
      dispatch(merchantGetListFailed());
    }
  });
};

const convertSetMerchantToDB = (data) => {
  const { name, merchantId, secretKey } = data;

  return {
    name,
    merchantId,
    secretKey,
  };
};

const createMerchant = (data) => dispatch => {
  const token = getToken();
  const convertedData = convertSetMerchantToDB(data);

  dispatch(merchantStartFormSubmit());

  ws.emit('api/app/wayForPayMerchants/create', { token, payload: convertedData }, (result) => {
    const { status } = result;

    if (status === 'ok') {
      dispatch(merchantFormSubmitSuccess());
    } else {
      dispatch(merchantFormSubmitFailed());
    }
  });
};

const convertDBMerchantToEdit = payload => {
  const { merchant: merchantFromDB } = payload;
  const {
    name, merchantId, secretKey, isArchive, created, modified, createdAt, updatedAt,
  } = merchantFromDB;

  const merchant = {
    name,
    merchantId,
    secretKey,
  };

  const statistic = {
    created: `${created.name} ${created.surname}`,
    createdAt: moment(createdAt).format("LLL"),
    updated: `${modified.name} ${modified.surname}`,
    updatedAt: moment(updatedAt).format("LLL"),
    isArchive,
  };

  return { merchant, statistic };
};

const getMerchant = merchantId => dispatch => {
  const token = getToken();
  dispatch(merchantGetFormProgress());

  ws.emit('api/app/wayForPayMerchants/getById', { token, payload: { merchantId } }, (result) => {
    const { status, payload } = result;

    if (status === 'ok') {
      dispatch(merchantGetFormSuccess(convertDBMerchantToEdit(payload)));
    } else {
      dispatch(merchantGetFormFailed());
    }
  });
};

const updateMerchant = (id, data) => dispatch => {
  const token = getToken();
  const convertedData = convertSetMerchantToDB(data);

  dispatch(merchantStartFormSubmit());

  ws.emit('api/app/wayForPayMerchants/updateById', { token, payload: { merchantId: id, data: convertedData} }, (result) => {
    const { status } = result;

    if (status === 'ok') {
      dispatch(merchantFormSubmitSuccess());
    } else {
      dispatch(merchantFormSubmitFailed());
    }
  });
};

export {
  WAY_FOR_PAY_MERCHANTS_GET_LIST_PROGRESS,
  WAY_FOR_PAY_MERCHANTS_GET_LIST_SUCCESS,
  WAY_FOR_PAY_MERCHANTS_GET_LIST_FAILED,
  WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_PROGRESS,
  WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_SUCCESS,
  WAY_FOR_PAY_MERCHANTS_FORM_SUBMIT_FAILED,
  WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_PROGRESS,
  WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_SUCCESS,
  WAY_FOR_PAY_MERCHANTS_GET_MERCHANT_FAILED,
  WAY_FOR_PAY_MERCHANTS_CLEAR_STATE,
  merchantClearState,
  getMerchantsList,
  createMerchant,
  getMerchant,
  updateMerchant,
};
